import Amplify from "@aws-amplify/core";
import Auth from "@aws-amplify/auth";
import { DataStore } from "@aws-amplify/datastore";
import { Dent } from "./models";
import awsconfig from "./aws-exports/";

import { Elm } from "./Main.elm";

window.app = Elm.Main.init({ node: document.querySelector("#app") });

Amplify.configure(awsconfig);
DataStore.configure(awsconfig);

window.Auth = Auth;
window.me = function me() {
  Auth.currentAuthenticatedUser().then(console.log);
}

window.DataStore = DataStore;
window.Dent = Dent;

function signUp(payload) {
  console.log("signUp");
  Auth.signUp({username: payload.email, password: payload.password}).then(
    (payload) => {
      console.info("resolve", payload);
      app.ports.resolvedSignUp.send(payload);
    },
    (payload) => {
      console.error("reject", payload);
      app.ports.rejectedSignUp.send(payload.message);
    }
  );
}

function confirmSignUp(payload) {
  console.log("confirmSignUp");
  Auth.confirmSignUp(payload.email, payload.password).then(
    (payload) => {
      console.info("resolve", payload);
      app.ports.resolvedConfirmSignUp.send(payload);
    },
    (payload) => {
      console.error("reject", payload);
      app.ports.rejectedConfirmSignUp.send(payload.message);
    }
  );
}

function signIn(payload) {
  console.log("signIn");
  Auth.signIn(payload.email, payload.password).then(
    (payload) => {
      console.info("resolve", payload);
      app.ports.resolvedSignIn.send(payload);
    },
    (payload) => {
      console.error("reject", payload);
      app.ports.rejectedSignIn.send(payload.message);
    }
  );
}

function signOut(payload) {
  console.log("signout", payload);
  Auth.signOut().then(() => {
    DataStore.clear();
    subscription.unsubscribe();
    subscription = null;
    app.ports.signedOut.send("");
  })
}

function handleCurrentAuthenticatedUser() {
  console.log("handleCurrentAuthenticatedUser");
  Auth.currentAuthenticatedUser().then(
    (payload) => {
      console.info("resolve", payload);
      app.ports.resolvedCurrentAuthenticatedUser.send(payload);
    },
    (payload) => {
      console.error("reject", payload);
      app.ports.rejectedCurrentAuthenticatedUser.send(payload);
    }
  );
}

let subscription;

function queryDents() {
  console.log("queryDents");
  DataStore.query(Dent).then(
  (payload) => {
    console.info("resolve", payload);
    app.ports.resolvedQueryDents.send(payload);
    if (!subscription) {
      subscription = DataStore.observe(Dent).subscribe(handleDentsSubscription);
    }
  },
  (payload) => {
    console.error("reject", payload);
    app.ports.rejectedQueryDents.send(payload);
  });
}

function handleDentsSubscription(payload) {
  console.info(payload);
  app.ports.resolvedQueryDents.send([payload.element]);
}

function createDent(attrs) {
  console.log("createDent", attrs);
  DataStore.save(new Dent(attrs)).then(() => {
    console.info("resolve", "");
    app.ports.resolvedCreateDent.send("");
  },
  (payload) => {
    console.error("reject", payload);
    app.ports.rejectedCreateDent.send(payload);
  });
}

function updateDent(attrs) {
  console.log("updateDent", attrs);
  DataStore.query(Dent, attrs.id).then((original) => {
    DataStore.save(Dent.copyOf(original, updated => {
      updated.parentId = attrs.parentId;
      updated.content = attrs.content;
      updated.position = attrs.position;
      updated.done = attrs.done
      updated.expanded = attrs.expanded
      updated.updatedAt = attrs.updatedAt
      updated.updatedBySessionId = attrs.updatedBySessionId
    }));
  }).then(() => {
    console.info("resolve", "");
    app.ports.resolvedUpdateDent.send("");
  },
  (payload) => {
    console.error("reject", payload);
    app.ports.rejectedUpdateDent.send(payload);
  });
}

function deleteDent(id) {
  console.log("deleteDent", id);
  DataStore.query(Dent, id).then(dent => DataStore.delete(dent))
  .then(() => {
    console.info("resolve", "");
    app.ports.resolvedDeleteDent.send("");
  },
  (payload) => {
    console.error("reject", payload);
    app.ports.rejectedDeleteDent.send(payload);
  });
}

app.ports.signUp.subscribe(signUp);
app.ports.confirmSignUp.subscribe(confirmSignUp);
app.ports.signIn.subscribe(signIn);
app.ports.signOut.subscribe(signOut);
app.ports.currentAuthenticatedUser.subscribe(handleCurrentAuthenticatedUser);

app.ports.queryDents.subscribe(queryDents);
app.ports.createDent.subscribe(createDent);
app.ports.updateDent.subscribe(updateDent);
app.ports.deleteDent.subscribe(deleteDent);

window.addEventListener("click", (event) => {
  if (event.target.id === "create") {
    document.getElementById("hack").focus();
    document.getElementById("hack").click();
  }
});
